import { DateCell } from "../Utils/DataTable/Cells"

const POAM_CELLS = {
  'Original Detection Date': DateCell,
  'Scheduled Completion Date': DateCell,
  'Status Date': DateCell,
  'Last Vendor Check-in Date': DateCell
}

export default POAM_CELLS